// extracted by mini-css-extract-plugin
export default {"list":"nature_list__Pme9U"};